import React, { useEffect } from 'react';
import { Bot, Calendar, Zap } from 'lucide-react';
import { useData } from '../context/DataContext';
import CategoryTabs from '../components/CategoryTabs';

const Automation = () => {
  const { getContentByCategory, trackPageView } = useData();

  useEffect(() => {
    trackPageView('automation');
  }, [trackPageView]);

  const subcategories = [
    {
      name: 'Job Scheduling',
      icon: Calendar,
      description: 'Automate routine tasks with SQL Server Agent jobs, scheduling, and job monitoring.',
      scripts: getContentByCategory('Automation', 'Job Scheduling')
    },
    {
      name: 'PowerShell Scripts',
      icon: Bot,
      description: 'PowerShell automation scripts for SQL Server administration and maintenance tasks.',
      scripts: getContentByCategory('Automation', 'PowerShell Scripts')
    },
    {
      name: 'Maintenance Plans',
      icon: Zap,
      description: 'Automated maintenance plans for index optimization, statistics updates, and cleanup.',
      scripts: getContentByCategory('Automation', 'Maintenance Plans')
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Automation</h1>
        <p className="page-description">
          Streamline SQL Server administration with automation scripts, job scheduling, 
          and maintenance plans. Reduce manual effort and improve operational efficiency.
        </p>
      </div>

      <CategoryTabs 
        category="Automation"
        scripts={getContentByCategory('Automation')}
        articles={getContentByCategory('Automation', null, 'articles')}
        subcategories={subcategories}
      />
    </div>
  );
};

export default Automation;